export type PlanGateFeature =
  | 'market_catalog'
  | 'platform_rfq'
  | 'platform_chat'
  | 'buyer_suppliers'
  | 'market_price_intelligence'

export const upgradeTariffLabel = 'Сменить тариф'

const onPaidPlans = 'доступно на тарифах «Стандарт» и «Премиум»'

/** Canonical paywall copy aligned with epic §6 and core PlanBillingMessages. */
export const paywallCopy = {
  marketAndRfq: `Доступ к рынку и заявкам поставщикам ${onPaidPlans}.`,
  platformRfq: `Заявки поставщикам на платформе ${onPaidPlans}.`,
  platformChat: `Чат по платформенным сделкам ${onPaidPlans}.`,
  buyerSuppliers: `Список платформенных поставщиков ${onPaidPlans}.`,
  marketPriceIntelligence: 'Аналитика цен доступна на тарифе «Премиум».',
  seatLimitStart:
    'На тарифе «Старт» доступен один пользователь. Чтобы добавить команду — обновите тариф до «Стандарт» или «Премиум».',
  seatLimitStandard:
    'На тарифе «Стандарт» доступно до 3 пользователей. Для расширения обновите тариф до «Премиум».',
  deviceLimit:
    'На вашем тарифе разрешено одно устройство на пользователя. Выйдите на другом устройстве или обновите тариф до «Премиум».',
  myPricesSupplierLimit:
    'На тарифе «Старт» можно вести прайсы до 5 поставщиков. Обновите тариф до «Стандарт» или «Премиум».',
  venueLimitStartStandard: 'Подключение нескольких заведений доступно на тарифе «Премиум».',
  venueAddonRequired: 'В «Премиум» входят 3 заведения. Подключите следующее (+3 000 ₽/мес).',
  ownerOnly: 'Этот раздел доступен только владельцу аккаунта.',
} as const

export const planGateCopy: Record<PlanGateFeature, { title: string; message: string }> = {
  market_catalog: {
    title: 'Каталог рынка',
    message: paywallCopy.marketAndRfq,
  },
  platform_rfq: {
    title: 'Заявки поставщикам',
    message: paywallCopy.platformRfq,
  },
  platform_chat: {
    title: 'Чат',
    message: paywallCopy.platformChat,
  },
  buyer_suppliers: {
    title: 'Поставщики',
    message: paywallCopy.buyerSuppliers,
  },
  market_price_intelligence: {
    title: 'Аналитика цен',
    message: paywallCopy.marketPriceIntelligence,
  },
}

export const myPricesRefreshCooldownMessage = (nextAvailableAt?: string): string => {
  const dateLabel = nextAvailableAt?.trim() || 'позже'
  return `На «Старте» прайс поставщика можно обновлять не чаще одного раза в неделю. Следующее обновление: ${dateLabel}. Обновите тариф до «Стандарт» или «Премиум», чтобы снять ограничение.`
}

export const seatLimitFallbackMessage = (currentPlan?: string): string => {
  if (currentPlan === 'standard') {
    return paywallCopy.seatLimitStandard
  }
  if (currentPlan === 'start') {
    return paywallCopy.seatLimitStart
  }
  return 'Достигнут лимит пользователей для вашего тарифа. Обновите тариф до «Стандарт» или «Премиум».'
}

export const billingFeatureFallbackMessage = (_requiredPlanDisplayName?: string): string =>
  'Действие недоступно. Обновите тариф до «Стандарт» или «Премиум».'

export const deviceTakeoverCopy = {
  title: 'Вы уже вошли на другом устройстве',
  primary: 'Войти здесь',
  dismiss: 'Отмена',
} as const

/** Текст промпта «войти здесь» с данными активного устройства (если пришли из API). */
export const deviceTakeoverMessage = (activeDeviceLabel?: string, lastSeenText?: string): string => {
  const device = activeDeviceLabel?.trim()
  const seen = lastSeenText?.trim()
  const where = device
    ? `Сейчас активно устройство «${device}»${seen ? ` (последний вход: ${seen})` : ''}.`
    : 'Сейчас активна сессия на другом устройстве.'
  return `На вашем тарифе доступно одно устройство. ${where} Войти здесь? На другом устройстве произойдёт выход.`
}
